import AttendanceRescheduleFormContainer from './AttendanceRescheduleFormContainer';

export default AttendanceRescheduleFormContainer;
